import { openBlock as e, createElementBlock as c, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M6.6 3.75c-1.167 0-2.05.892-2.05 1.917a.75.75 0 0 1-.75.75c-1.167 0-2.05.892-2.05 1.916 0 1.025.883 1.917 2.05 1.917h9.1c.78 0 1.35-.594 1.35-1.25s-.57-1.25-1.35-1.25a.75.75 0 0 1-.742-.861c.13-.869-.666-1.806-1.708-1.806-.327 0-.629.086-.884.231a.75.75 0 0 1-1.061-.357C8.209 4.264 7.479 3.75 6.6 3.75ZM3.121 4.98C3.454 3.4 4.911 2.25 6.6 2.25a3.59 3.59 0 0 1 2.916 1.467 3.31 3.31 0 0 1 .934-.134c1.592 0 3.02 1.223 3.204 2.765C14.844 6.664 15.75 7.71 15.75 9c0 1.553-1.31 2.75-2.85 2.75H3.8c-1.926 0-3.55-1.496-3.55-3.417 0-1.69 1.257-3.05 2.871-3.353Z",
  "clip-rule": "evenodd"
}, null, -1), l = [
  n
];
function r(d, s) {
  return e(), c("svg", t, [...l]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
